export interface FallbackConfig {
  routeName: string;
  analyticsName: string;
  buildDeepLink: (params: URLSearchParams) => string | null;
}

export const accountRecoveryConfig: FallbackConfig = {
  routeName: 'Account Recovery',
  analyticsName: 'Account Recovery',
  buildDeepLink: (params: URLSearchParams) => {
    const code = params.get('recovery_code') ?? params.get('code');
    if (!code) return null;
    return `nyx://account_recovery_deep_link?code=${encodeURIComponent(code)}`;
  },
};

export const fitbitOAuthConfig: FallbackConfig = {
  routeName: 'Fitbit OAuth',
  analyticsName: 'Fitbit OAuth',
  buildDeepLink: (params: URLSearchParams) => {
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !state) return null;
    return `nyx://fitbit/oauth?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`;
  },
};

export const garminOAuthConfig: FallbackConfig = {
  routeName: 'Garmin OAuth',
  analyticsName: 'Garmin OAuth',
  buildDeepLink: (params: URLSearchParams) => {
    const oauthToken = params.get('oauth_token');
    const oauthVerifier = params.get('oauth_verifier');
    if (!oauthToken || !oauthVerifier) return null;
    return `nyx://garmin/oauth?oauth_token=${encodeURIComponent(oauthToken)}&oauth_verifier=${encodeURIComponent(
      oauthVerifier,
    )}`;
  },
};
